import React from "react";

export const ContextSwitcherSvg = () => (
  <svg height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect height="4" rx="2" width="4" x="14" y="14" />
      <rect height="4" rx="2" width="4" x="7" y="14" />
      <rect height="4" rx="2" width="4" y="14" />
      <rect height="4" rx="2" width="4" x="14" y="7" />
      <rect height="4" rx="2" width="4" x="7" y="7" />
      <rect height="4" rx="2" width="4" y="7" />
      <rect height="4" rx="2" width="4" x="14" />
      <rect height="4" rx="2" width="4" x="7" />
      <rect height="4" rx="2" width="4" />
    </g>
  </svg>
);
